import { render, staticRenderFns } from "./AppTabela.vue?vue&type=template&id=6a108f29&scoped=true&"
import script from "./AppTabela.vue?vue&type=script&lang=js&"
export * from "./AppTabela.vue?vue&type=script&lang=js&"
import style0 from "./AppTabela.vue?vue&type=style&index=0&id=6a108f29&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a108f29",
  null
  
)

export default component.exports